module.exports = __webpack_public_path__ + "media/images/sp/brands/an/_main-visual-text-001875218849ff905c832643642887e4.svg";